import { types } from 'mobx-state-tree';
import DropoffLocation from './DropoffLocation';

export default types.model('ShippingInstructions', {
  uid: types.string,
  item_title: types.string,
  item_image: types.string,
  item_price: types.number,
  shipping_service: types.string,
  shipper: types.string,
  label_url: types.string,
  tracking_url: types.string,
  requires_label: types.boolean,
  shipper_will_pickup: types.boolean,
  estimated_pickup: types.string,
  estimated_delivery: types.string,
  dropoff_locations: types.maybe(types.array(DropoffLocation)),
  shipment_direction: types.string,
});
